import { render, staticRenderFns } from "./xeTodoWidget.vue?vue&type=template&id=1c7abe80&scoped=true"
import script from "./xeTodoWidget.vue?vue&type=script&lang=js"
export * from "./xeTodoWidget.vue?vue&type=script&lang=js"
import style0 from "./xeTodoWidget.vue?vue&type=style&index=0&id=1c7abe80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7abe80",
  null
  
)

export default component.exports